import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EFAirConditioner from '@elem/ui-assets/icons/appliances/EFAirConditioner';
import EFElectricKettle from '@elem/ui-assets/icons/appliances/EFElectricKettle';
import EFIH from '@elem/ui-assets/icons/appliances/EFIH';
import EFLaptop from '@elem/ui-assets/icons/appliances/EFLaptop';
import EFTV from '@elem/ui-assets/icons/appliances/EFTV';
import EFWashingMachine from '@elem/ui-assets/icons/appliances/EFWashingMachine';
import EcoImg from 'eco-design/base/eco-img';
import EFLight from 'elem/ui-assets/icons/appliances/EFLight';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import { useState } from 'react';
import css from './index.module.scss';

interface SubItemType {
    name: string;
    text: React.ReactNode;
    icon: JSX.Element;
}
interface ItemType {
    img: [string, string];
    name: string;
    text: string;
    tab: string;
    subs: SubItemType[];
}

const ICON1 = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 3.375C23.3135 3.375 26.3146 4.7189 28.4854 6.88965C30.6561 9.0604 32 12.0615 32 15.375C32 18.6885 30.6561 21.6896 28.4854 23.8604C26.9552 25.3905 25.0118 26.5068 22.8379 27.0342L23.7236 31.625H26.7607C26.7541 31.5849 26.75 31.5439 26.75 31.502V29.125C26.75 28.7108 27.0858 28.375 27.5 28.375C27.9142 28.375 28.25 28.7108 28.25 29.125V31.502C28.25 31.5439 28.2459 31.5849 28.2393 31.625H30L30.2559 31.6377C31.5164 31.7658 32.5 32.8307 32.5 34.125C32.5 35.4193 31.5164 36.4842 30.2559 36.6123L30 36.625H10C8.61929 36.625 7.5 35.5057 7.5 34.125C7.5 32.7443 8.61929 31.625 10 31.625H16.3184L17.1699 27.0352C14.993 26.5085 13.0466 25.3923 11.5146 23.8604C9.3439 21.6896 8 18.6885 8 15.375C8 12.0615 9.3439 9.0604 11.5146 6.88965C13.6854 4.7189 16.6865 3.375 20 3.375ZM10 33.125C9.44772 33.125 9 33.5727 9 34.125C9 34.6773 9.44772 35.125 10 35.125H30C30.5523 35.125 31 34.6773 31 34.125C31 33.5727 30.5523 33.125 30 33.125H10ZM21.3613 27.2969C20.9144 27.3474 20.4603 27.375 20 27.375C19.5424 27.375 19.0908 27.3478 18.6465 27.2979L17.8438 31.625H22.1953L21.3613 27.2969ZM20 4.875C17.1003 4.875 14.4761 6.04925 12.5752 7.9502C10.6742 9.85114 9.5 12.4753 9.5 15.375C9.5 18.2747 10.6742 20.8989 12.5752 22.7998C14.4761 24.7008 17.1003 25.875 20 25.875C22.8997 25.875 25.5239 24.7008 27.4248 22.7998C29.3258 20.8989 30.5 18.2747 30.5 15.375C30.5 12.4753 29.3258 9.85114 27.4248 7.9502C25.5239 6.04925 22.8997 4.875 20 4.875ZM21.8037 7.4707C22.1024 7.19888 22.5531 6.96323 23.083 7.1123C23.7381 7.29684 24.5427 7.69401 25.1748 8.25977C25.7994 8.81894 26.3772 9.6614 26.2432 10.71C26.1412 11.5073 25.6484 12.3553 25.043 13.1289C24.4892 13.8364 23.7811 14.5561 23.0098 15.2246C23.0119 15.2742 23.0146 15.3239 23.0146 15.374C23.0146 15.813 22.9296 16.2325 22.7783 16.6182C23.906 17.3599 24.808 18.0469 25.4082 18.6504C25.7393 18.9834 26.0233 19.3345 26.1855 19.6934C26.3517 20.0614 26.4365 20.5626 26.1309 21.0205C25.7529 21.5865 25.1269 22.2289 24.3936 22.6553C23.6687 23.0765 22.6883 23.3656 21.7324 22.9141C21.0058 22.5707 20.3513 21.8401 19.8027 21.0254C19.328 20.3203 18.8859 19.4803 18.5029 18.5957C18.007 18.4256 17.5625 18.1453 17.2002 17.7832C17.0147 17.5977 16.85 17.3906 16.7109 17.166C15.3538 17.7165 14.1896 18.0972 13.2979 18.252C12.8352 18.3322 12.3851 18.3639 11.998 18.291C11.6011 18.2161 11.1412 17.9976 10.9414 17.4844C10.6945 16.85 10.5272 15.9684 10.5986 15.123C10.6694 14.2878 10.9951 13.3198 11.9131 12.7959C12.6112 12.3975 13.5852 12.2809 14.5674 12.2988C15.4856 12.3157 16.5112 12.4527 17.5312 12.6748C18.1058 12.2322 18.8268 11.9678 19.6084 11.9678C19.6885 11.9678 19.7679 11.9711 19.8467 11.9766C20.2289 10.5318 20.6324 9.34991 21.0518 8.53223C21.2661 8.11433 21.5125 7.73597 21.8037 7.4707ZM21.9365 17.8594C21.4678 18.2986 20.8738 18.6061 20.2139 18.7246C20.478 19.2626 20.7596 19.7594 21.0479 20.1875C21.5563 20.9425 22.0227 21.393 22.373 21.5586C22.6897 21.7081 23.1163 21.6635 23.6396 21.3594C24.1096 21.0863 24.5358 20.6652 24.8086 20.292C24.749 20.171 24.6113 19.9761 24.3447 19.708C23.8459 19.2065 23.0355 18.5814 21.9365 17.8594ZM19.6084 13.4678C19.0819 13.4678 18.6065 13.6807 18.2607 14.0264C17.915 14.3721 17.7022 14.8474 17.7021 15.374C17.7021 15.9006 17.915 16.3759 18.2607 16.7217C18.6065 17.0673 19.0819 17.2803 19.6084 17.2803C20.1348 17.2802 20.6104 17.0674 20.9561 16.7217C21.3017 16.3759 21.5146 15.9005 21.5146 15.374C21.5146 14.8475 21.3017 14.3721 20.9561 14.0264C20.6104 13.6807 20.1348 13.4679 19.6084 13.4678ZM14.5391 13.7988C13.6293 13.7823 12.9929 13.9058 12.6562 14.0977C12.3521 14.2713 12.1438 14.6468 12.0928 15.25C12.047 15.7915 12.1477 16.3819 12.2969 16.8193C12.4302 16.8399 12.6687 16.839 13.041 16.7744C13.7916 16.6441 14.8663 16.2987 16.2227 15.7451C16.2094 15.6232 16.2021 15.4994 16.2021 15.374C16.2022 14.8853 16.3046 14.4202 16.4902 14C15.7995 13.8802 15.1343 13.8097 14.5391 13.7988ZM22.7988 8.59473C22.7022 8.68875 22.5594 8.88026 22.3867 9.2168C22.0364 9.89986 21.6612 10.9766 21.2842 12.4092C21.5535 12.5617 21.8007 12.7489 22.0176 12.9658C22.2163 13.1647 22.3902 13.3886 22.5352 13.6318C23.0429 13.155 23.4966 12.6702 23.8613 12.2041C24.4226 11.487 24.7067 10.9039 24.7559 10.5195C24.8001 10.1721 24.6258 9.78068 24.1748 9.37695C23.7699 9.01455 23.238 8.7388 22.7988 8.59473Z"
            fill="black"
        />
    </svg>
);

const ICON2 = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_9734_44229)">
            <path
                d="M28.5 3C29.7426 3 30.75 4.00736 30.75 5.25V34.75C30.75 35.9926 29.7426 37 28.5 37H11.5C10.2574 37 9.25 35.9926 9.25 34.75V5.25C9.25 4.00736 10.2574 3 11.5 3H28.5ZM11.5 4.5C11.0858 4.5 10.75 4.83579 10.75 5.25V34.75C10.75 35.1642 11.0858 35.5 11.5 35.5H28.5C28.9142 35.5 29.25 35.1642 29.25 34.75V5.25C29.25 4.83579 28.9142 4.5 28.5 4.5H11.5ZM20 30C21.0355 30 21.875 30.8395 21.875 31.875C21.875 32.9105 21.0355 33.75 20 33.75C18.9645 33.75 18.125 32.9105 18.125 31.875C18.125 30.8395 18.9645 30 20 30ZM22.5 6.75C22.9142 6.75 23.25 7.08579 23.25 7.5C23.25 7.91421 22.9142 8.25 22.5 8.25H17.5C17.0858 8.25 16.75 7.91421 16.75 7.5C16.75 7.08579 17.0858 6.75 17.5 6.75H22.5Z"
                fill="black"
            />
        </g>
        <defs>
            <clipPath id="clip0_9734_44229">
                <rect width="40" height="40" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const ICON3 = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.2471 5.5C22.7838 5.5 24.0705 6.56678 24.4092 8H27.5C29.9853 8 32 10.0147 32 12.5V14.3379C33.4332 14.6766 34.5 15.9633 34.5 17.5V20C34.5 21.5366 33.4331 22.8224 32 23.1611V29.25C32 32.1495 29.6495 34.5 26.75 34.5H13.25C10.3505 34.5 8.00002 32.1495 8 29.25V23.1611C6.56688 22.8224 5.50004 21.5366 5.5 20V17.5C5.5 15.9633 6.56676 14.6766 8 14.3379V12.5C8 10.0147 10.0147 8 12.5 8H15.585C15.9236 6.56678 17.2104 5.5 18.7471 5.5H21.2471ZM9.5 29.25C9.50002 31.3211 11.1789 33 13.25 33H26.75C28.8211 33 30.5 31.3211 30.5 29.25V27H24.4971V28.75C24.4971 29.1642 24.1613 29.5 23.7471 29.5H16.2471C15.8329 29.5 15.4971 29.1642 15.4971 28.75V27H9.5V29.25ZM19.9971 19.5C18.3403 19.5 16.9971 20.8432 16.9971 22.5V26.1914C16.9986 26.2107 17 26.2303 17 26.25C17 26.2691 16.9985 26.2879 16.9971 26.3066V28H22.9971V26.3066C22.9957 26.2879 22.9941 26.2691 22.9941 26.25C22.9941 26.2303 22.9956 26.2107 22.9971 26.1914V22.5C22.997 20.8432 21.6539 19.5 19.9971 19.5ZM9.5 25.5H15.4971V22.5C15.4971 20.0148 17.5118 18 19.9971 18C22.4823 18 24.497 20.0148 24.4971 22.5V25.5H30.5V13.25H9.5V25.5ZM19.9932 22.5C20.6835 22.5 21.2432 23.0596 21.2432 23.75C21.2432 24.4404 20.6835 25 19.9932 25C19.3028 25 18.7432 24.4404 18.7432 23.75C18.7432 23.0596 19.3028 22.5 19.9932 22.5ZM8 15.9209C7.4093 16.202 7 16.8023 7 17.5V20C7.00004 20.6977 7.40931 21.298 8 21.5791V15.9209ZM32 21.5791C32.5907 21.298 33 20.6977 33 20V17.5C33 16.8023 32.5907 16.202 32 15.9209V21.5791ZM12.5 9.5C11.1024 9.5 9.93095 10.4565 9.59766 11.75H30.4023C30.069 10.4565 28.8976 9.5 27.5 9.5H12.5ZM18.7471 7C18.0494 7 17.449 7.40931 17.168 8H22.8262C22.5451 7.40931 21.9448 7 21.2471 7H18.7471Z"
            fill="black"
        />
    </svg>
);

const F: React.FC = () => {
    const { t } = useLang('d3u');
    const [active, setActive] = useState<number>(0);
    const items: ItemType[] = [
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760923981531/6_1.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760923979669/6_1_M.jpg'],
            tab: t('F_item1_tab'),
            name: t('F_item1_name'),
            text: t('F_item1_text'),
            subs: [
                {
                    name: t('F_item1_sub1_name'),
                    text: 'F_item1_sub1_text',
                    icon: <EFRefrigerator />,
                },
                {
                    name: t('F_item1_sub2_name'),
                    text: 'F_item1_sub2_text',
                    icon: <EFLight />,
                },
                {
                    name: t('F_item1_sub3_name'),
                    text: 'F_item1_sub3_text',
                    icon: <ICON1 />,
                },
                {
                    name: t('F_item1_sub4_name'),
                    text: 'F_item1_sub4_text',
                    icon: <EFLaptop />,
                },
                {
                    name: t('F_item1_sub5_name'),
                    text: 'F_item1_sub5_text',
                    icon: <EFTV />,
                },
                {
                    name: t('F_item1_sub6_name'),
                    text: 'F_item1_sub6_text',
                    icon: <EFElectricKettle />,
                },
                {
                    name: t('F_item1_sub7_name'),
                    text: 'F_item1_sub7_text',
                    icon: <ICON2 />,
                },
            ],
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760923981872/6_2.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760923982246/6_2_M.jpg'],
            tab: t('F_item2_tab'),
            name: t('F_item2_name'),
            text: t('F_item2_text'),
            subs: [
                {
                    name: t('F_item2_sub1_name'),
                    text: 'F_item2_sub1_text',
                    icon: <EFRefrigerator />,
                },
                {
                    name: t('F_item2_sub2_name'),
                    text: 'F_item2_sub2_text',
                    icon: <EFLight />,
                },
                {
                    name: t('F_item2_sub3_name'),
                    text: 'F_item2_sub3_text',
                    icon: <ICON1 />,
                },
                {
                    name: t('F_item2_sub4_name'),
                    text: 'F_item2_sub4_text',
                    icon: <EFIH />,
                },
                {
                    name: t('F_item2_sub5_name'),
                    text: 'F_item2_sub5_text',
                    icon: <EFWashingMachine />,
                },
                {
                    name: t('F_item2_sub6_name'),
                    text: 'F_item2_sub6_text',
                    icon: <EFTV />,
                },
                {
                    name: t('F_item2_sub7_name'),
                    text: 'F_item2_sub7_text',
                    icon: <EFElectricKettle />,
                },
                {
                    name: t('F_item2_sub8_name'),
                    text: 'F_item2_sub8_text',
                    icon: <ICON2 />,
                },
            ],
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760923979881/6_3.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760923980263/6_3_M.jpg'],
            tab: t('F_item3_tab'),
            name: t('F_item3_name'),
            text: t('F_item3_text'),
            subs: [
                {
                    name: t('F_item3_sub1_name'),
                    text: 'F_item3_sub1_text',
                    icon: <EFRefrigerator />,
                },
                {
                    name: t('F_item3_sub2_name'),
                    text: 'F_item3_sub2_text',
                    icon: <EFLight />,
                },
                {
                    name: t('F_item3_sub3_name'),
                    text: 'F_item3_sub3_text',
                    icon: <ICON3 />,
                },
                {
                    name: t('F_item3_sub4_name'),
                    text: 'F_item3_sub4_text',
                    icon: <EFIH />,
                },
                {
                    name: t('F_item3_sub5_name'),
                    text: 'F_item3_sub5_text',
                    icon: <EFWashingMachine />,
                },
                {
                    name: t('F_item3_sub6_name'),
                    text: 'F_item3_sub6_text',
                    icon: <EFTV />,
                },
                {
                    name: t('F_item3_sub7_name'),
                    text: 'F_item3_sub7_text',
                    icon: <EFElectricKettle />,
                },
                {
                    name: t('F_item3_sub8_name'),
                    text: 'F_item3_sub8_text',
                    icon: <ICON2 />,
                },
            ],
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760923980603/6_4.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760923980917/6_4_M.jpg'],
            tab: t('F_item4_tab'),
            name: t('F_item4_name'),
            text: t('F_item4_text'),
            subs: [
                {
                    name: t('F_item4_sub1_name'),
                    text: 'F_item4_sub1_text',
                    icon: <EFRefrigerator />,
                },
                {
                    name: t('F_item4_sub2_name'),
                    text: 'F_item4_sub2_text',
                    icon: <EFLight />,
                },
                {
                    name: t('F_item4_sub3_name'),
                    text: 'F_item4_sub3_text',
                    icon: <EFIH />,
                },
                {
                    name: t('F_item4_sub4_name'),
                    text: 'F_item4_sub4_text',
                    icon: <ICON3 />,
                },
                {
                    name: t('F_item4_sub5_name'),
                    text: 'F_item4_sub5_text',
                    icon: <EFWashingMachine />,
                },
                {
                    name: t('F_item4_sub6_name'),
                    text: 'F_item4_sub6_text',
                    icon: <EFTV />,
                },
                {
                    name: t('F_item4_sub7_name'),
                    text: 'F_item4_sub7_text',
                    icon: <EFElectricKettle />,
                },
                {
                    name: t('F_item4_sub8_name'),
                    text: 'F_item4_sub8_text',
                    icon: <ICON2 />,
                },
            ],
        },
        {
            img: ['https://websiteoss.ecoflow.com/upload/image/1760923981191/6_5.jpg', 'https://websiteoss.ecoflow.com/upload/image/1760923982559/6_5_M.jpg'],
            tab: t('F_item5_tab'),
            name: t('F_item5_name'),
            text: t('F_item5_text'),
            subs: [
                {
                    name: t('F_item5_sub1_name'),
                    text: 'F_item5_sub1_text',
                    icon: <EFRefrigerator />,
                },
                {
                    name: t('F_item5_sub2_name'),
                    text: 'F_item5_sub2_text',
                    icon: <EFLight />,
                },
                {
                    name: t('F_item5_sub3_name'),
                    text: 'F_item5_sub3_text',
                    icon: <EFIH />,
                },
                {
                    name: t('F_item5_sub4_name'),
                    text: 'F_item5_sub4_text',
                    icon: <EFAirConditioner />,
                },
                {
                    name: t('F_item5_sub5_name'),
                    text: 'F_item5_sub5_text',
                    icon: <EFWashingMachine />,
                },
                {
                    name: t('F_item5_sub6_name'),
                    text: 'F_item5_sub6_text',
                    icon: <EFTV />,
                },
                {
                    name: t('F_item5_sub7_name'),
                    text: 'F_item5_sub7_text',
                    icon: <ICON2 />,
                },
            ],
        },
    ];

    const handleChangeTab = (tx: string, k: number) => {
        if (active !== k) {
            setActive(k);
            gtm.push({
                event: 'uaEvent',
                event_name: 'tab_click',
                list_name: t('F_title'),
                button_name: tx,
                __btn_id1: `${css.section} .tab-${k + 1}`,
                __btn_id2: tx,
                __btn_type: 'text',
            });
            const parent: HTMLUListElement | null = document.querySelector('.D3U-F .tabs');
            if (k > items.length / 2 && parent) {
                parent.scrollTo({
                    left: parent.scrollWidth / 2,
                    behavior: 'smooth',
                });
            } else if (k <= items.length / 2 && parent) {
                parent.scrollTo({
                    left: 0,
                    behavior: 'smooth',
                });
            }
        }
    };

    return (
        <section className={`${css.section} D3U-F GtmModuleData-section`} id="D3U-F" data-section-id={'D3U-F'} data-section-id2={t('F_title')}>
            <div className="info">
                <p className="title">{t('F_title')}</p>
                <p className="desc">{t('F_desc')}</p>
            </div>
            <ul className="items">
                {items.map((item: ItemType, k: number) => (
                    <li className={`item${active === k ? ' active' : ''}`} key={k}>
                        <div className="msg">
                            <p className="name">{item.name}</p>
                            <p className="text">{item.text}</p>
                            <ul className="subs">
                                {item.subs.map((sub: SubItemType, k: number) => (
                                    <li className="sub" key={k}>
                                        <div className="sub-icon">{sub.icon}</div>
                                        <p className="sub-name">{sub.name}</p>
                                        <p className="sub-text">
                                            {t.rich(sub.text, {
                                                b: (tx: string) => <span className="b">{tx}</span>,
                                            })}
                                        </p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="img">
                            <EcoImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                        </div>
                    </li>
                ))}
            </ul>
            <ul className="tabs">
                {items.map((item: ItemType, k: number) => (
                    <li
                        className={`tab${active === k ? ' active' : ''} tab-${k + 1} GtmModuleData-btn-text`}
                        key={k}
                        onClick={() => handleChangeTab(item.tab, k)}
                    >
                        <p className="name">{item.tab}</p>
                    </li>
                ))}
            </ul>
            <p className="tip">
                {t('F_tip')}
                {[3, 4].includes(active) ? t('F_tip_append') : ''}
            </p>
        </section>
    );
};

export default F;
